import {TreatmentRequestDiagnosisSection} from '@/features/treatment-requests/components/treatment-request-diagnosis-section/TreatmentRequestDiagnosisSection'
import {TreatmentRequestScoresSection} from '@/features/treatment-requests/components/treatment-request-scores-section/TreatmentRequestScoresSection'
import {TreatmentRequestTreatmentSection} from '@/features/treatment-requests/components/treatment-request-treatment-section/TreatmentRequestTreatmentSection'
import {TreatmentRequestNotesSection} from '@/features/treatment-requests/components/treatment-request-notes-section/TreatmentRequestNotesSection'
import {Divider} from '@/components/ui/divider/Divider'

export const TreatmentRequestEditableSections = () => {
    return (
        <>
            <TreatmentRequestDiagnosisSection />
            <TreatmentRequestTreatmentSection />
            <TreatmentRequestScoresSection />
            <Divider direction="horizontal" />
            <TreatmentRequestNotesSection />
        </>
    )
}
